import { atom, useAtom } from "jotai";

import { defaultMarket, marketList } from "#/config/markets";
import type { Market, UnderlyingSymbol } from "#/types/markets";

export const positionsDrawerMarketAtom = atom<Market>(defaultMarket);

export const setPositionsDrawerMarketByUnderlyingAtom = atom(
  null,
  (_, set, underlying: UnderlyingSymbol) => {
    const market =
      marketList.find((item) => item.underlying === underlying) ??
      defaultMarket;

    set(positionsDrawerMarketAtom, market);
  },
);

export const usePositionsDrawerMarket = () => {
  const [market, setMarket] = useAtom(positionsDrawerMarketAtom);
  const [, setMarketByUnderlying] = useAtom(
    setPositionsDrawerMarketByUnderlyingAtom,
  );

  return {
    market,
    setMarket,
    setMarketByUnderlying,
  };
};
